import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";
import AskQuestion from "@/pages/AskQuestion";
import IRSNoticeReview from "@/pages/IRSNoticeReview";
import TaxDiagnostic from "@/pages/TaxDiagnostic";
import TaxResolution from "@/pages/TaxResolution";
import TaxPreparation from "@/pages/TaxPreparation";
import SmallBusiness from "@/pages/SmallBusiness";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import BookConsultation from "@/pages/BookConsultation";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import TruckDriverTax from "@/pages/TruckDriverTax";
import SecondLookReview from "@/pages/SecondLookReview";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import FreeConsultation from "@/pages/FreeConsultation";
import TaxReliefPricing from "@/pages/TaxReliefPricing";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ask" element={<AskQuestion />} />
          <Route path="/services/irs-notice" element={<IRSNoticeReview />} />
          <Route path="/services/diagnostic" element={<TaxDiagnostic />} />
          <Route path="/services/resolution" element={<TaxResolution />} />
          <Route path="/services/preparation" element={<TaxPreparation />} />
          <Route path="/services/small-business" element={<SmallBusiness />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/book" element={<BookConsultation />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/services/truck-driver-tax" element={<TruckDriverTax />} />
          <Route path="/services/second-look-review" element={<SecondLookReview />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/free-consultation" element={<FreeConsultation />} />
          <Route path="/tax-relief-pricing" element={<TaxReliefPricing />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
